import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsuarioUnidadeService {
  private data = null;
  private url = environment.serviceApi;
  
  constructor(public http: Http) { }

  getUsuarioUnidades(usuario) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/usuariounidades/' + usuario)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
  }
}
